<template>
  <div class="cproduct">
    <div>
      <div v-if="'simple'!=type" class="cproduct-desc"></div>
      <div :class="'simple'==type?'cproduct-name2':'cproduct-name'">B2B<span style="font-family: YouSheBiaoTiHei;font-weight: 400">小程序</span></div>
      <div class="cproduct-content">
        小程序商城解决方案致力于为企业提供多渠道电商解决方案，通过自建商城，以及营销系统、会员系统帮助企业搭建新一代微商城销售体系，快速实现去中心化流量聚合，客户粉丝沉淀，助力企业快速步入移动电商时代.
      </div>
      <div class="cproduct-button" @click="toProduct()">
        <div class="cproduct-button-text">查询详情</div>
        <img class="more-icon" src="../assets/more.png"/>
      </div>
    </div>
    <div v-if="'simple'!=type" class="cproduct-button-example"></div>
    <div class="top-icon" @click="scrollTo()"></div>
  </div>
</template>

<script>
  export default {
    name: "CProduct",
    props:{
      type:{
        type:String
      }
    },
    methods:{
      scrollTo() {
        var scrollToTop = setInterval(function () {
          var pos = window.pageYOffset;

          if (pos > 0) {
            window.scrollTo(0, pos - 20);
          } else {
            window.clearInterval(scrollToTop);
          }
        }, 10);
      },
      toProduct(){
        this.$router.push({
          name:"Production"
        })
      }
    }
  }
</script>

<style scoped>
  .cproduct {
    display: flex;
    width: 1070px;
    margin: 0 auto;
  }

  .cproduct-desc {
    background-image: url("../../static/wz3.png");
    width: 466px;
    height: 39px;
  }

  .cproduct-name {
    font-size: 24px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #333333;
    line-height: 36px;
    margin-top: 18px;
  }

  .cproduct-name2 {
    margin-top: 18px;
    font-size: 30px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #333333;
    line-height: 45px;
    letter-spacing: 1px;
  }

  .cproduct-content {
    text-indent: 32px;
    width: 468px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #081457;
    line-height: 21px;
    margin-top: 18px;
  }
  .cproduct-button{
    background-image: url("../assets/Rectangle11.png");
    width: 214px;
    height: 100px;
    display: flex;
    margin-top: 39px;
    cursor: pointer;
  }
  .cproduct-button-text{
    margin-left: 52px;
    color: #fff;
    font-size: 15px;
    line-height: 50px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    margin-top: 15px;
  }
  .more-icon{
    width: 13px;
    height: 12px;
    margin-top: 34px;
    margin-left: 35px;
  }
  .cproduct-button-example{
    background-image: url("../assets/b2c.png");
    width: 487px;
    height: 388px;
    margin-left: 69px;
    margin-top: 48px;
    background-size: cover;
  }
  .top-icon{
    width: 70px;
    height: 70px;
    box-shadow: 0px 6px 10px 0px rgba(0, 2, 77, 0.1);
    border-radius: 6px;
    border: 3px solid #F6F8FF;
    position: absolute;
    bottom: 27px;
    left: 50%;
    margin-left: 620px;
    background: #FFFFFF url("../assets/btn_hddb.png") no-repeat center;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/CProduct.vue